// @flow
import React from "react"
import { sortBy, prop } from "ramda"
import { type HOC } from "recompose"
import withQuery from "hoc/withQuery"
import { filterableParametersQuery } from "data/search/graphql/queries/params"
import type { SearchParams } from "data/search/types"
import type { ProductGroup, Location } from "data/app/types"
import Multiselect from "searchFilters/Shared/Multiselect"
import Loader from "components/Loader"
import Submodal from "./Submodal"

const EnumFilterSubmodal = ({
  data,
  paramKey,
  onChange,
  value,
  back,
  loading,
}) => {
  const paramData = data && data[paramKey]
  const options = paramData && paramData.type === "enum_value" && sortBy(prop("name"), paramData.enum.values)

  return (
    <Submodal
      back={back}
      title={paramKey}
      clear={() => onChange({ [paramKey]: [] })}
    >
      {loading ? (
        <Loader />
      ) : (
        options && (
          <Multiselect
            options={options}
            value={value[paramKey] || []}
            onChange={x => onChange({ [paramKey]: x })}
          />
        )
      )}
    </Submodal>
  )
}

type Outter = {|
  paramKey: string,
  onChange: SearchParams => mixed,
  value: SearchParams,
  geolocation: ?Location[],
  productGroups: ?ProductGroup[],
  back: Function,
|}

const enhancer: HOC<*, Outter> = withQuery(filterableParametersQuery, {
  variables: props => ({
    productGroups: props.productGroups && props.productGroups.map(productGroup => productGroup.name),
    locationIds: props.geolocation && props.geolocation.map(geo => geo.id),
    affiliateIds: props.value.affiliate ? [props.value.affiliate] : undefined,
  }),
  noLoader: true,
  noEmpty: true,
})

export default enhancer(EnumFilterSubmodal)



// WEBPACK FOOTER //
// ./src/modals/SetActivityFilters/EnumFilterSubmodal/index.js